export const OptOutIconConfig = {
  Urls: {
    French: 'https://privacy-center.sharethrough.com/fr/consumer-privacy-notice/#4',
    Default: 'https://privacy-center.sharethrough.com/en/consumer-privacy-notice/#4'
  }
};
